import type { Building } from "building-types/building/buildingTypes";
import { defaultGenerationStages } from "../stages/defaultGenerationStages";
import type { GenerateBuildingOptions } from "../types/generateBuildingTypes";
import generateBuildingWithStages from "./generateBuildingWithStages";

/**
 * Generates a building using the default stage pipeline when `options.stages` is omitted.
 *
 * Wrapper function that provides queuing behavior (see `generateBuildingWithStages`).
 * Multiple calls are queued - only the final call returns a building.
 * Previous calls wait for the current operation to complete and return the same result.
 *
 * If options.queueId is undefined, skips queuing and runs immediately.
 */
export default async function generateBuilding(options: GenerateBuildingOptions): Promise<Building> {
  return generateBuildingWithStages({
    ...options,
    stages: options.stages ?? defaultGenerationStages,
  });
}
